// @ vendors
const download = require('downloadjs');
const trim = require('lodash/string/trim');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const { updateConsents } = require('actions/gdprConsents');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

// @ utilities
const { formatText } = require('core/i18n').i18n;
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getCreditCardHiringStatus, getCardStandard, } = require('utilities/hireCardsHelper');
const DateHelper = require('utilities/dateHelper');
const { nonNumericFilter } = require('utilities/stringHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { get } = require('lodash');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const {
  API_CHANNEL,
  DATE_FORMAT_SHORT_MONTH_SHORT_YEAR,
  SECOND_STEP,
  VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
  VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
  VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
  WIZARD_SECOND_STEP,
} = require('constants/index');
const { VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { CREDIT_CARD_REVOLVING_PROCESS, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');


function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_RESET,
  };
}
function resetDIR() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET,
  };
}
const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(resetWizard());
  dispatch(resetDIR());
  dispatch(resetPreContractualInfo());
};

const setAccount = accountId => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SET_ACCOUNT,
  payload: {
    accountId,
  },
});

const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};

function onHandleChangeCheckBoxCC() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SET_AGREEMENT_CHECKBOX_CC
  };
}

const setVisibleStep = step => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SET_VISIBLE_STEP,
  payload: {
    step,
  },
});

const validateAccount = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_VALIDATE_ACCOUNT,
});

function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_PROCCESS_EMAIL_SUCCESS,
  };
}

function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_PROCCESS_EMAIL_ERROR,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function hireCardVirtualCreditprintDocument() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_PRINT_DOCUMENT,
  };
}
function hireCardVirtualCreditprintDocumentPolicy() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_PRINT_DOCUMENT_POLICY,
  };
}
function hireCardVirtualCreditCheckedRadioButton(check) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_CHECK_RADIO_BUTTON,
    payload: {
      check,
    },
  };
}
function hireCardVirtualCreditCheckedRadioButtonPolicy(check) {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_CHECK_RADIO_BUTTON_POLICY,
    payload: {
      check,
    },
  };
}

const validate = (step, externalComponentsAreValid, isRevolving = false) => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_VALIDATE_STEP,
  payload: {
    step,
    valid: externalComponentsAreValid,
    isRevolving,
  },
});

const newValidate = (step, externalComponentsAreValid, isRevolving = false) => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_NEW_VALIDATE_STEP,
  payload: {
    step,
    valid: externalComponentsAreValid,
    isRevolving,
  },
});

function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_AGREEINECHECKBOX,
  };
}
const hireCreditCardDocumentRead = (documentType) => {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CARD_DOCUMENT_READ,
    payload: {
      documentType
    }
  }
}
const hireCreditCardAllDocumentRead = () => {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CARD_ALL_DOCUMENT_READ
  }
}
const hireCreditCardsaveDocumentAccepted = (documentsList, dmsDocumentType, documentChanges) => {
  return {
    type: actionTypes.HIRE_CARD_VIRTUAL_CARD_SAVE_DOCUMENT_ACCEPTED,
    payload: { documentsList, dmsDocumentType, documentChanges }
  }
}
function hireCardNerudaCheckedRadioButtonIneDir(check) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON_INE_DIR,
    payload: {
      check,
    },
  };
}
const setWillCancel = willCancel => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_WILL_CANCEL,
  payload: {
    willCancel,
  },
});

const validateFirstAndThirdStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

  newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
    ? dispatch(newValidate(step, true, showIneAndRevolving))
    : dispatch(validate(step, true, showIneAndRevolving));
};

const validateSecondStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const accountIsValid = getState().hireCardVirtualCredit.getIn([
    'steps',
    step - 1,
    'accountIsValid',
  ]);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') < immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
      ? dispatch(newValidate(step, allComponentsAreValid, showIneAndRevolving))
      : dispatch(validate(step, allComponentsAreValid, showIneAndRevolving));
  }
};

const validateINEStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCardVirtualCredit.getIn([
    'steps',
    step - 1,
    'accountIsValid',
  ]);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  const immHireCardVirtualCredit = getState().hireCardVirtualCredit
  const documentINE = immHireCardVirtualCredit.get('documentINE')
  newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
    ? dispatch(newValidate(step, allComponentsAreValid))
    : dispatch(validate(step, allComponentsAreValid))
  return !documentINE && allComponentsAreValid && dispatch(hireCardCreditINE.getInitINEstep(immHireCardVirtualCredit));
};
const validateINEDIRStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCardVirtualCredit.getIn([
    'steps',
    step - 1,
    'accountIsValid',
  ]);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  const immHireCardVirtualCredit = getState().hireCardVirtualCredit
  const documentINE = immHireCardVirtualCredit.get('documentINE')
  newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
    ? dispatch(newValidate(step, allComponentsAreValid))
    : dispatch(validate(step, allComponentsAreValid))
  return !documentINE && allComponentsAreValid && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireCardVirtualCredit));

};
const validatePolicyStep = () => (dispatch, getState) => {
  const immHireCardVirtualCredit = getState().hireCardVirtualCredit;
  const documentPolicy = immHireCardVirtualCredit.get('documentPolicy');
  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireCardVirtualCredit));
};
const validateThirdStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  (!__CONTACT_CENTER__ || isPrintOfficeMode()) && dispatch(newValidate(step, true, showIneAndRevolving));
};
const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardVirtualCredit.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const immHireCardVirtualCredit = getState().hireCardVirtualCredit
  const documentId = immHireCardVirtualCredit.get('documentId')
  const operationProcessIdInit = immHireCardVirtualCredit.get('operationProcessIdInit')
  const hireCreditCard = getState().hireCreditCard;
  let acceptanceText;
  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    acceptanceText = 'NA'
  }
  if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
  }
  if (!__CONTACT_CENTER__) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
  }
  const documentIdDIR = hireCreditCard.get('documentIdDIR')

  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      documents: [
        {
          documentId: immHireCardVirtualCredit.get('documentIdINE'),
          scrollDown: true,
        },
        ...(documentIdDIR ? [{
          documentId: documentIdDIR,
          scrollDown: true,
        }] : [])
      ],
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());

      }
    });

};

const validateStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const immHireCreditCard = getState().hireCreditCard;
  const policyDocument = immHireCreditCard.get('documentPolicy')
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

  if (newCardsFF) {
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
      if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardVirtualCreditFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === WIZARD_SECOND_STEP) {
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateSecondStep(step));
        dispatch(validateINEStep(step))
          .then(() => {
            dispatch(validatePolicyStep());
          })
      } else if (step === 1 || step === 3) {
        //FIRST_STEP AND FIFTH_STEP
        dispatch(validateFirstAndThirdStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    } else {
      if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardVirtualCreditFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === WIZARD_SECOND_STEP) {
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateSecondStep(step));
        dispatch(validateINEDIRStep(step));

      } else if (step === 3) {
        !policyDocument && dispatch(processEmail())
          .then(() => {
            dispatch(validatePolicyStep());
          })
        dispatch(validateThirdStep(step));
        !isPrintOfficeMode() && dispatch(agreeIneCheckbox());
      } else if (step === 1 || step === 4) {
        dispatch(validateFirstAndThirdStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    }
  } else {
    if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardVirtualCreditFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === WIZARD_SECOND_STEP) {
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 1 || step === 3) {
      //FIRST_STEP AND FIFTH_STEP
      dispatch(validateFirstAndThirdStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));
  }

};

const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardVirtualCreditRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardVirtualCreditFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardVirtualCreditSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardVirtualCreditFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardVirtualCreditFailure());
      } else {
        throw response;
      }
    });
};

const myCardsTarjetasHire = () => (dispatch, getState) => {
  const hireCardVirtualCredit = getState().hireCardVirtualCredit;
  const callback = (dispatch, getState, dataToken) => {

    const contractNumberAccount = hireCardVirtualCredit.get('contractNumberAccount');
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails = null;
    let numDomicilio = null;

    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA' : __CONTACT_CENTER__ && isPrintOfficeMode() ? formatText('hireCardOpenCreditStepINE-acceptanceTextOffice') : formatText('hireCardOpenCreditHeaderPolicy-header')

    const data = {
      processType: 'contract',
      documentId: hireCardVirtualCredit.get('documentIdPolicy'),
      operationProcessId: hireCardVirtualCredit.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
          tipo: VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
          standard: VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: false,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: hireCardVirtualCredit.get('scrollDownPolicy'),
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
        type: VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setCardVirtualCredit(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCardVirtualCreditCheckedRadioButton(check));
}

const checkRadioButtonPolicy = (check) => (dispatch, getState) => {
  dispatch(hireCardVirtualCreditCheckedRadioButtonPolicy(check));
}

const printDocument = () => (dispatch, getState) => {
  dispatch(hireCardVirtualCreditprintDocument());
}

const printDocumentPolicy = () => (dispatch, getState) => {
  dispatch(hireCardVirtualCreditprintDocumentPolicy());
}


const hireCardVirtualCreditRequest = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_REQUEST,
});

const hireCardVirtualCreditSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardVirtualCreditFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});

const generateVirtualCardPDFRequest = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_GENERATE_PDF_REQUEST,
});

const generateVirtualCardPDFFailure = response => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_GENERATE_PDF_FAILURE,
  payload: {
    response,
  },
});

const generateVirtualCardPDFSuccess = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_GENERATE_PDF_SUCCESS,
});

const hireVirtualCardGetTextReliefSuccess = response => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_GET_TEXT_RELIEF_SUCCESS,
  payload: {
    response,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_VIRTUAL_CREDIT_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardVirtualCredit = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
    header: {
      version: 2,
    },
  };

  dispatch(hireCardVirtualCreditRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardVirtualCreditFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardVirtualCreditSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(
            setTermsAndCondsInfo(VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData)
          );
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardVirtualCreditFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardVirtualCreditFailure());
      } else {
        throw response;
      }
    });
};

const hireCardVirtualCredit = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardVirtualCredit.getIn(['steps', SECOND_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

    const data = {
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: '0000001',
          subTipo: '803',
          tipo: '500',
        },
        tipoFormaPago: immPaymentMethod.get('type'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
      },
      numDomicilio: null,
      deliverToProvidedDetails: false,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
        subType: VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
        type: VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() =>
        setCardVirtualCredit(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      )
      .catch(response => {
        if (!!response.error) {
          setCardVirtualCredit(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

const generatePDF = (dispatch, params) => {
  const { pan, cvc, date, holder } = params;
  const requestParams = {
    header: {
      responseType: 'arraybuffer',
      accept: 'application/pdf',
    },
    query: {
      pan: nonNumericFilter(pan),
      cvc,
      fecha: date,
      titular: holder.replace(/\*/g, ' '),
    },
  };

  return APIGet({
    dispatch,
    endpoint: 'ecardPdf',
    params: requestParams,
  })
    .then(response => {
      const eCardPdfName = formatText('hireCardECard-pdfFileName') + '.pdf';
      dispatch(generateVirtualCardPDFSuccess());
      download(response.xhr.response, eCardPdfName, 'application/pdf');
    })
    .catch(response => dispatch(generateVirtualCardPDFFailure(response.error)));
};

// TODO: we are going to finish this in other US
const downloadVirtualCreditPdf = () => (dispatch, getState) => {
  const immHireECardResponse = getState().hireCardECard.get('response');
  const pan = immHireECardResponse.get('cardNumber').replace(/ /g, '');
  const cvc = immHireECardResponse.getIn(['CVCCode', 'valueAttribute']);
  const date = DateHelper.formatDate(
    immHireECardResponse.get('expirationDate'),
    DATE_FORMAT_SHORT_MONTH_SHORT_YEAR
  );
  const holder = immHireECardResponse.get('textRelief');
  const contractNumber = immHireECardResponse.getIn(['cardContract', 'contractNumber']);
  const product = immHireECardResponse.getIn(['cardContract', 'product']);
  const params = {
    pan,
    cvc,
    date,
    contractNumber,
    product,
    holder,
  };

  dispatch(generateVirtualCardPDFRequest());

  if (!!holder) {
    generatePDF(dispatch, params);
  } else {
    const requestData = {
      header: {
        version: 3,
      },
      query: {
        pan,
        numeroContrato: contractNumber,
        producto: product,
      },
    };
    return APIPost({
      dispatch,
      endpoint: 'cardInformation',
      params: requestData,
    })
      .then(response => {
        dispatch(hireVirtualCardGetTextReliefSuccess(response));
        params.holder = trim(response.textoRelieve);
        generatePDF(dispatch, params);
      })
      .catch(response => {
        if (!!response.error) {
          dispatch(generateVirtualCardPDFFailure(response.error));
        } else {
          throw response;
        }
      });
  }
};
const documentRead = (documentType) => (dispatch, getState) => {

  dispatch(hireCreditCardDocumentRead(documentType));
};
const onAcceptAllDocument = () => (dispatch, getState) => {
  dispatch(hireCreditCardAllDocumentRead());
};
const saveDocumentList = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCreditCardsaveDocumentAccepted(documentsList, dmsDocumentType, documentChanges));
};
const checkRadioButtonIneDir = (check) => (dispatch, getState) => {
  dispatch(hireCardNerudaCheckedRadioButtonIneDir(check));
}
module.exports = {
  downloadVirtualCreditPdf,
  hireCardVirtualCredit,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
  checkRadioButton,
  printDocument,
  processEmail,
  onHandleChangeCheckBoxCC,
  myCardsTarjetasHire,
  printDocumentPolicy,
  checkRadioButtonPolicy,
  documentRead,
  onAcceptAllDocument,
  saveDocumentList,
  checkRadioButtonIneDir
};
